export default __webpack_public_path__ + "static/media/node.10c9e2aa.svg";